import { NoDataCard } from "../../../../components/parts";
import { ShaDowBox } from "../../../../components/boxes/ShadowBox";

export const GridBalancing = () => {
  const title = "Grid Balancing";

  return (
    <ShaDowBox fullHeight>
      <NoDataCard title={title} />
    </ShaDowBox>
  );
};
